import MapboxConfig from "@/plugins/mapbox";
import mapboxgl from "mapbox-gl";
import Vue from 'vue';
import geojsonPopup from "@/components/popup/geojsonPopup";
import layerTimePopup from "@/components/popup/layerTimePopup";
import ApiService from "@/services/api.service.js"

let GeojsonPopupClass = Vue.extend(geojsonPopup);
let LayerTimePopup = Vue.extend(layerTimePopup);

let map;
let popup;
let identifyVector = false;
let identifyProperties = {};
let identifyStore = {}

const MapServices = {
    initMap() {
        mapboxgl.accessToken = MapboxConfig.accessToken;
        map = new mapboxgl.Map({
            container: "map", // container id
            style: MapboxConfig.style, // style URL
            center: [12, 51], // starting position [lng, lat]
            zoom: 6, // starting zoom
            preserveDrawingBuffer: true
        });
        map.addControl(new mapboxgl.ScaleControl());
        map.addControl(new mapboxgl.NavigationControl());
        map.addControl(new mapboxgl.FullscreenControl());

        map.on('load', function () {
            map.addLayer({
                'id': 'sky',
                'type': 'sky',
                'paint': {
                    'sky-type': 'atmosphere',
                    'sky-atmosphere-sun': [0.0, 0.0],
                    'sky-atmosphere-sun-intensity': 15
                }
            });
        });
        //add event popUp
        popup = new mapboxgl.Popup()
        map.on('closePopupAll', (param) => {
            popup.remove();
        });
        map.on('click', async (e) => {
            if (e.clickOnLayer) {
                return;
            }
            if (!('layerId' in identifyProperties)) {
                return;
            }
            let { lng, lat } = e.lngLat
            lng = parseFloat(lng) ?? 0
            lat = parseFloat(lat) ?? 0
            let layerId = identifyProperties.layerId.toString()
            let layerClick = map.getStyle().layers.pop()['id'] === layerId ? true : false || false
            if (layerClick) {
                let url = `https://rastless.api.eomap.com/layers/ssm-daily-soil-6b13c7bfcf7a/${identifyProperties.timestamp}/statistic?token=c8c9633d-bf33-41d6-ab38-20666297ef92`
                let jsonParams = JSON.stringify({
                    "statistic": "median",
                    "geometry": {
                        "type": "Point",
                        "coordinates": [lng, lat]
                    }
                });
                map.getCanvas().style.cursor = 'wait';
                let result = await ApiService.post(url, jsonParams)
                map.getCanvas().style.cursor = '';
                let ifServiceData = result['data']['data']['B1'] !== null
                if(ifServiceData){
                    popup = new mapboxgl.Popup()
                    .setLngLat([lng, lat])
                    .setHTML('<div id="vue-popup-content">example</div>')
                    .addTo(map);
                let properties = {
                    "layerId": identifyProperties.layerId,
                    "keyLayer": identifyProperties.keyLayer,
                    "name": identifyProperties.name,
                    "timestamp": identifyProperties.timestamp,
                    "temporalResolution": identifyProperties.temporalResolution,
                    "lng": e.lngLat.lng,
                    "lat": e.lngLat.lat,
                    "dataB1": result.data.data.B1 || result.data.data.mean,
                    "plotLayout": identifyProperties.plotLayout
                }
                let popupInstance = new LayerTimePopup({
                    store: identifyStore,
                    propsData: {
                        properties
                    }
                })
                popupInstance.$mount('#vue-popup-content')
                popup._update()
                }
            }
        });
        map.on('mouseenter', () => {
            this.map.getCanvas().style.cursor = 'pointer';
        });
        map.on('mouseleave', () => {
            map.getCanvas().style.cursor = '';
        });
    }
}

class WmsLayer {
    constructor(layerInfos, _) {
        this.map = map
        this.url = layerInfos.url
        this.attribution = layerInfos.attribution || ""
        this.id = layerInfos.layerId.toString()
    }

    async add() {
        if (!this.map.getSource(this.id)) {
            await map.addSource(this.id, {
                'type': 'raster',
                'tiles': [
                    this.url
                ],
                'tileSize': 256,
                "attribution": this.attribution
            });
        }
        this.map.addLayer({
            id: this.id,
            type: "raster",
            source: this.id,
            paint: {}
        })
    }

    delete() {
        if (this.map.getLayer(this.id)) {
            this.map.removeLayer(this.id)
        }
    }
}


class DynamicBandLayer {
    constructor(layerInfos, _) {
        this.map = map
        this.url = layerInfos.url
        this.bands = layerInfos.bands
        this.attribution = layerInfos.attribution || ""
        this.id = layerInfos.layerId.toString()
    }

    async add() {
        if (!this.map.getSource(this.id)) {
            const bandExpr = this.bands.join(";")
            const url = `${this.url}&expr=${bandExpr}`

            await map.addSource(this.id, {
                'type': 'raster',
                'tiles': [
                    url
                ],
                'tileSize': 256,
                "attribution": this.attribution
            });
        }
        this.map.addLayer({
            id: this.id,
            type: "raster",
            source: this.id,
            paint: {}
        })
    }

    delete() {
        if (this.map.getLayer(this.id)) {
                this.map.removeLayer(this.id)
                if (this.map.getSource(this.id)) {
                    this.map.removeSource(this.id)
                }
            }
    }

    update() {
        this.delete()
        this.add()
    }
}


class TilexyzLayer {
    constructor(layerInfos, store) {
        this.map = map
        this.url = layerInfos.url
        this.attribution = layerInfos.attribution || ""
        this.id = layerInfos.layerId.toString()
        this.name = layerInfos.name || ""
        this.layerInfos = layerInfos
        this.timestamp = layerInfos.timestamp || ""
        this.keyLayer = layerInfos.keyLayer || ""
        identifyStore = store
    }
    set(datetime) {
        identifyProperties = this.layerInfos
        this.url = this.url.replace('{timestamp}', datetime)
    }
    async add() {
        if (!this.map.getSource(this.id)) {
            await map.addSource(this.id, {
                'type': 'raster',
                'tiles': [
                    this.url
                ],
                'tileSize': 256,
                "attribution": this.attribution
            });
        }
        if (!this.map.getLayer(this.id)) {
            this.map.addLayer({
                id: this.id,
                type: "raster",
                source: this.id,
                paint: {}
            })
        }
    }
    delete() {
            if (this.map.getLayer(this.id)) {
                this.map.removeLayer(this.id)
                if (this.map.getSource(this.id)) {
                    this.map.removeSource(this.id)
                }
            }
    }

    update() {
        this.delete()
        this.add()
    }
}
class GeojsonLayer {
    constructor(layerInfos, store) {
        this.map = map
        this.url = layerInfos.url
        this.attribution = layerInfos.attribution || ""
        this.id = layerInfos.name
        this.promoteId = layerInfos.promoteId || ""
        this.store = store
    }
    async add() {
        if (!this.map.getSource(this.id)) {
            let sourceSettings = {
                'type': 'geojson',
                'data': this.url,
            }
            if (this.promoteId !== "") {
                sourceSettings["promoteId"] = this.promoteId
            } else {
                sourceSettings["generateId"] = true
            }
            await map.addSource(this.id, sourceSettings);
        }
        this.map.addLayer({
            id: this.id,
            type: "circle",
            source: this.id,
            paint: {
                'circle-radius': {
                    'base': 3,
                    'stops': [
                        [12, 3],
                        [18, 180]
                    ]
                },
                "circle-color": "red"
            }
        })

        map.on('click', this.id, (e) => {
            const coordinates = e.features[0].geometry.coordinates.slice();
            const properties = e.features[0].properties

            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }
            map.fire('closePopupAll');
            popup = new mapboxgl.Popup({keepInView: true})
                .setLngLat(coordinates)
                .setHTML('<div id="vue-popup-content"></div>')
                .on('open', e => {
                    identifyVector = false;
                })
                .addTo(map);

            let popupInstance = new GeojsonPopupClass({
                store: this.store,
                propsData: {
                    properties: properties
                }
            })

            popupInstance.$mount('#vue-popup-content')
            popup._update()
        });

        map.on('mouseenter', this.id, function () {
            map.getCanvas().style.cursor = 'pointer';
        });

        map.on('mouseleave', this.id, function () {
            map.getCanvas().style.cursor = '';
        });
    }

    delete() {
        if (this.map.getLayer(this.id)) {
            this.map.removeLayer(this.id)
        }
    }
}

export {WmsLayer,TilexyzLayer, GeojsonLayer, DynamicBandLayer}

export default MapServices;
